import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const HeroSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  return (
    <section className="base-section hero-section main-hp" id="HP_hero_bed">
      <Link href={tLink('bed')} noTabbing noClass>
        <div className="desktop-viewport">
          <div className="img-wrap">
            <picture>
              <source
                srcSet="/images/homepage/heroSection/le-meridien-hero-mob.jpg"
                media="(max-width: 768px)"
              />
              <img
                src="/images/homepage/heroSection/le-meridien-hero.jpg"
                alt="Le Méridien"
                width={960}
                height={750}
                loading="eager"
                fetchPriority="high"
              />
            </picture>
          </div>
          <div className="stack">
            <h1 className="main-section-title">{t('title')}</h1>
            <p className="main-section-copy">{t('copy')}</p>
            <Button ariaLabel={`${tButton('joieDeVivreBtn')}: ${t('title')}`} className="white">
              {tButton('joieDeVivreBtn')}
            </Button>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default HeroSection;
